import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-sidenav-mobile',
  imports: [],
  templateUrl: './sidenav-mobile.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sidenav-mobile.component.scss',
})
export class SidenavMobileComponent {}
